import React, { useEffect, useRef, useState, useContext } from "react";
import './Disengagement.css';
import { urlApiServer, urlApiServerImage } from "../../Component/Config/Config";
import SignatureCanvas from 'react-signature-canvas';
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";
import logo from '../../Assest/LogoSingefin.png'

function Disengagement() {

    const urlGetLinkage = urlApiServer + "Linkages?populate=*"
    const urlPostDescriptionOfDisengagements = urlApiServer + "description-of-disengagements"
    const urlPostUploadLinkage = urlApiServer + "upload/"

    const sigCanvas = useRef(null);

    const [idCard, setIdCard] = useState('')
    const [name, setName] = useState('')
    const [surnames, setSurnames] = useState('')
    const [currentPosition, setCurrentPosition] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [filingDate, setFilingDate] = useState('')
    const [signature, setSignature] = useState('')
    const [explains, setExplains] = useState('')
    const [data, setData] = useState([]);

    const { infoUser, setInfoUser } = useContext(LoginContext)

    const urlDeleteLinkage = urlApiServer + "linkingforms/" + infoUser.usuario.documentId

    console.log("usuario documentId desde el frontend:", infoUser.usuario.documentId);

    const urlDeleteUpload = urlApiServer + "upload/files/" + infoUser.firma.id

    console.log("firma documentId desde el frontend:", infoUser.firma.id);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (infoUser.isLoged === false) {
            window.location.href = './Inicio';
        }
    }, [infoUser])

    useEffect(() => {
        if (infoUser.isLoged === true) {
            setName(infoUser.usuario.nombres)
            setSurnames(infoUser.usuario.apellidos)
            setIdCard(infoUser.usuario.cedula_ciudadania)
            setCurrentPosition(infoUser.usuario.cargo_actual)
            setPhone(infoUser.usuario.celular_contacto)
            setEmail(infoUser.usuario.correo)
            setFilingDate(infoUser.usuario.fecha_afiliacion)
        }
    }, [infoUser])

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetLinkage, requestOptions)
                    .then(response => response.json())
                    .then(DisengagementResponse => {
                        console.log('info del Disengagement: ', DisengagementResponse.data);
                        setData(DisengagementResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }

        })();

    }, [urlGetLinkage]);

    const clearSignature = () => {
        if (sigCanvas.current) {
            sigCanvas.current.clear();
            setSignature(null);
        }
    };

    const saveSignature = () => {
        if (sigCanvas.current && sigCanvas.current.isEmpty()) {
            Swal.fire({
                title: "Error",
                text: "Por favor, dibuja tu firma antes de guardar",
                icon: "error",
                allowOutsideClick: false
            });
        } else {
            const signatureData = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
            setSignature(signatureData);
            Swal.fire({
                title: "Correcto",
                text: "Se ha guardado correctamente la firma",
                icon: "success",
                allowOutsideClick: false
            });
        }
    };


    function headleNames(e) {
        setName(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleSurnames(e) {
        setSurnames(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleidCard(e) {
        setIdCard(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleFilingDate(e) {
        setFilingDate(e.target.value); // Para un input tipo fecha, usa `value`
    }

    function headleCurrentPosition(e) {
        setCurrentPosition(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headlePhone(e) {
        setPhone(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleEmail(e) {
        setEmail(e.target.value); // Para un input tipo email, usa `value`
    }

    function headleExplains(e) {
        setExplains(e.target.value); // Para un input tipo fecha, usa `value`
    }

    async function postFormDisengagement() {
        if (!signature) {
            Swal.fire({
                title: "Error",
                text: "Porfavor, no olvides poner tu firma",
                icon: "error",
                allowOutsideClick: false
            });
            return;
        }

        const deleteImage = await fetch(urlDeleteUpload, {
            method: 'DELETE',  // Método DELETE para eliminar el recurso
            headers: {
                'Content-Type': 'application/json',  // Tipo de contenido JSON
            },
        })

        if (deleteImage.ok) {

            console.log('Se eliminó la imagen');

            // Convert signature data URL to Blob (a file-like object)
            const byteString = atob(signature.split(',')[1]); // Remove "data:image/png;base64,"
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const uintArray = new Uint8Array(arrayBuffer);

            for (let i = 0; i < byteString.length; i++) {
                uintArray[i] = byteString.charCodeAt(i);
            }


            const file = new Blob([arrayBuffer], { type: 'image/png' });

            const fileData = new FormData();
            fileData.append('files', file, `desvinculado${name}${surnames}.png`); // 'signature.png' is the name for the file

            const requestOptionsFile = {
                method: 'POST',
                body: fileData,
                redirect: 'follow',
            };

            try {
                const dataPost = JSON.stringify({
                    data: {
                        nombres: name,
                        apellidos: surnames,
                        cedula: idCard,
                        fecha_radicacion: filingDate,
                        cargo_actual: currentPosition,
                        celular_contacto: phone,
                        correo: email,
                        descripcion: explains,
                        firma: 'desvinculado' + name + surnames + '.png' // Here, use the image filename or the URL returned after uploading
                    },
                });

                const registerHeaders = new Headers();
                registerHeaders.append("Content-Type", "application/json");

                const requestOptions = {
                    method: 'POST',
                    headers: registerHeaders,
                    body: dataPost,
                    redirect: 'follow',
                };

                // Enviar solicitud POST
                const response = await fetch(urlPostDescriptionOfDisengagements, requestOptions);
                const dataPostResponse = await response.json();
                try {
                    console.log('dataPostResponse: ', dataPostResponse);

                    const responseFile = await fetch(urlPostUploadLinkage, requestOptionsFile);
                    const dataPostUploadResponse = await responseFile.json();
                    console.log('The image has been uploaded:', dataPostUploadResponse);

                    const deleteLinkageResponse = await fetch(urlDeleteLinkage, {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                    if (deleteLinkageResponse.ok) {
                        Swal.fire({
                            title: "Correcto",
                            text: "Se ha eliminado correctamente el perfil, se cerrara tu cuenta",
                            icon: "success",
                            allowOutsideClick: false,
                            confirmButtonText: "Entendido"
                        }).then(() => {
                            setInfoUser({
                                isLoged: false,
                                usuario: "unknow",
                                firma: "unknow",
                            })
                            window.location.href = './Inicio';
                        });
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: "Ocurrio un problema para eliminar tu perfil",
                            icon: "error",
                            allowOutsideClick: false
                        });
                    }

                } catch (error) {
                    console.error('No se envio la informacion para la explicacion de eliminar la cuenta:', error);

                    Swal.fire({
                        title: "Error",
                        text: "Ocurrio un problema para eliminar tu perfil",
                        icon: "error",
                        allowOutsideClick: false
                    });

                }

            } catch (error) {

                console.log('error para guardar la firma: ', error)

                Swal.fire({
                    title: "Error",
                    text: "Ocurrio un problema con la firma",
                    icon: "error",
                    allowOutsideClick: false
                });
            }
        } else {
            Swal.fire({
                title: "Error",
                text: "Ocurrio un problema con la firma",
                icon: "error",
                allowOutsideClick: false
            });
        }
    }

    return (
        <div className="containerDisengagementSection">
            <div className="containerBannerDisengagement">
                <div className="bannerDisengagement">
                    <div
                        style={{
                            backgroundImage: data.length > 0 && data[0].imagen_portada_vinculacion?.url
                                ? `url(${urlApiServerImage}${data[0].imagen_portada_vinculacion.url})`
                                : "url('../../Assest/temporary/bannerHome.png')", // Imagen de respaldo
                            justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}
                        className="imageBannerDisengagement"
                    >
                        {data.length > 0 && data[0] ? (
                            <p className="titleBannerDisengagement">
                                {data.length > 0 && data[0].titulo_portada_desvinculacion ? data[0].titulo_portada_desvinculacion : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                </div>
            </div>
            <div className="containerInfoDisengagementSection">
                {data.length > 0 && data[0].texto_seccion_desvinculacion ? (
                    data[0].texto_seccion_desvinculacion.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>`
                                        return child.bold ? (
                                            <p key={i} className="titleInfoLegalSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textInfoDisengagementSection">
                                                {child.text}
                                            </p>
                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textInfoDisengagementSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textInfoDisengagementSection">...</p>
                )}
            </div>
            <div className="containerFormDisengagementSection">
                <div className="cardFormnDisengagementSection">
                    <div className="containerInputsDisengagementSection">
                        <input
                            type="text"
                            name="names"
                            placeholder="Nombres"
                            value={name}
                            onChange={headleNames}
                            className="inputsDisengagementSection"
                        />
                        <input
                            type="text"
                            name="surnames"
                            placeholder="Apellidos"
                            value={surnames}
                            onChange={headleSurnames}
                            className="inputsDisengagementSection"
                        />
                    </div>
                    <div className="containerInputsDisengagementSection">
                        <div className="">
                            <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                Fecha de nacimiento:
                            </p>
                            <input
                                type="date"
                                name="filingDate"
                                placeholder="Fecha de cumpleaños"
                                value={filingDate}
                                onChange={headleFilingDate}
                                className="inputsDisengagementSection"
                            />
                        </div>
                        <input
                            type="number"
                            name="idCard"
                            placeholder="cedula"
                            value={idCard}
                            onChange={headleidCard}
                            className="inputsDisengagementSection"
                        />
                    </div>
                    <div className="containerInputsDisengagementSection">
                        <input
                            type="text"
                            name="currentPosition"
                            placeholder="Cargo actual"
                            value={currentPosition}
                            onChange={headleCurrentPosition}
                            className="inputsDisengagementSection"
                        />
                    </div>
                    <div className="containerInputsDisengagementSection">
                        <input
                            type="email"
                            name="email"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={headleEmail}
                            className="inputsDisengagementSection"
                        />
                        <input
                            type="number"
                            name="phone"
                            placeholder="célular de contacto"
                            value={phone}
                            onChange={headlePhone}
                            className="inputsDisengagementSection"
                        />
                    </div>
                    <div className="containerInputsEndDisengagementSection">
                        <textarea
                            name="explains"
                            placeholder="Explica las razónes:"
                            value={explains}
                            onChange={headleExplains}
                            className="TextareaDisengagementSection"
                        />
                        <div className="containerSignature">
                            <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                Fecha de nacimiento:
                            </p>
                            <SignatureCanvas
                                ref={sigCanvas}
                                penColor="black"
                                canvasProps={{
                                    className: 'signatureDisengagementSection',
                                }}
                            />
                            <div className="containerButtonSignature">
                                <div className="cleaningAndSaveButton" onClick={clearSignature}>
                                    <p className="textCleaningAndSaveButton">
                                        Limpiar
                                    </p>
                                </div>
                                <div className="cleaningAndSaveButton" onClick={saveSignature}>
                                    <p className="textCleaningAndSaveButton">
                                        Guardar
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttonFormDisengagement" onClick={postFormDisengagement}>
                        <p className="textFormDisengagement">ENVIAR</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Disengagement;
